var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dialer-loader"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })]);

}]

export { render, staticRenderFns }